import React from "react";

import { Container, Row } from "react-bootstrap";

import "./Footer.css";

function Footer() {
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
          <nav className="footer-nav">
            <ul>
              <li>
                <a href="/home">HOME</a>
              </li>
              <li>
                <a href="/about">ABOUT</a>
              </li>
              {/* <li>
                <a href="/price">PRICE</a>
              </li>
              <li>
                <a href="/services">SERVICES</a>
              </li> */}
              <li>
                <a href="/portfolio">PORTFOLIO</a>
              </li>
              <li>
                <a href="/certificates">CERTIFICATES</a>
              </li>
              {/*<li>*/}
              {/*  <a href="/contact">CONTACT</a>*/}
              {/*</li>*/}
            </ul>
          </nav>
          <div className="credits ml-auto">
            <span className="copyright">
              Copyright © {new Date().getFullYear()} Vlad Hill
            </span>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
